'use client';

import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import { SWIPE } from '@/constants';
import Icon from '../Icon';
import Zoom from '../Zoom';
import Button from '../Button';
import ModalTitle from '../Typography/ModalTitle';

function ViewZoomInOut({ onView, onClose, data = [] }) {
  const [openModal, setOpenModal] = useState(null);
  const [translateY, setTranslateY] = useState(0);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleTranslateY = (value) => {
    setTranslateY(value);
  };

  const handleClose = (state) => {
    if (state === SWIPE) {
      setIsClosing(true);
      setTimeout(() => {
        setOpenModal(false);
        onClose(false);
        setTranslateY(0);
        setIsClosing(false);
      }, 200);
    } else {
      setOpenModal(false);
      onClose(false);
    }
  };

  return (
    <div
      className={cn(
        'w-full h-full bg-black/30 block lg:flex lg:justify-center lg:items-center opacity-30 fixed bottom-full left-0 right-0 -z-10 transition-opacity duration-100',
        {
          '!bottom-0 !opacity-100 !z-[502]': openModal,
        },
      )}
    >
      <div
        className={cn(
          'w-full lg:max-w-max lg:max-h-[1176px] m-0 lg:m-[100px] fixed lg:static bottom-[-440px] left-0 right-0 opacity-0 transition-all duration-[400ms]',
          {
            '!bottom-0 !opacity-100': openModal,
          },
        )}
      >
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={handleClose}
            className="size-[24px] cursor-pointer ml-auto"
          />
        </div>
        <div
          style={{
            transform: `translateY(${translateY}px)`,
            transition: isClosing
              ? 'transform 0.3s ease-out, opacity 0.3s ease-out'
              : 'transform 0.3s ease-out',
          }}
          className={cn(
            'bg-white w-full lg:max-w-[844px] lg:max-h-[1176px] p-20 lg:p-24 fixed lg:static bottom-[-440px] left-0 right-0 opacity-0 rounded-t-xl lg:rounded-xl transition-all duration-[400ms] shadow-job-search-filter',
            {
              '!bottom-0 !opacity-100': openModal,
            },
          )}
        >
          <Button
            type="modal-swipe-close-button"
            onTranslateY={handleTranslateY}
            onClose={handleClose}
          />
          <div className="flex justify-between gap-[10px] mb-16">
            <ModalTitle
              text="Product Image"
              className="text-base lg:text-xl text-fire-chalk font-bold lg:font-semibold"
            />
            <Icon
              type="close"
              onClick={handleClose}
              className="lg:hidden lg:size-[32px] cursor-pointer"
            />
          </div>
          {Array.isArray(data) && <Zoom images={data} />}
        </div>
      </div>
    </div>
  );
}

export default ViewZoomInOut;
